import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITemplateSelectionItem } from 'redux-store/api/template-selections';

export type TSelectedTemplateSelections = Record<string, ITemplateSelectionItem[]>;

interface ISelectSelectionPayload {
  costCodeId: string;
  selection: ITemplateSelectionItem;
}

interface IUnselectSelectSelectionPayload {
  costCodeId: string;
  selectionId: number;
}

interface ISelectAllSelectionsPayload {
  costCodeId: string;
  selections: ITemplateSelectionItem[];
}

interface IInitialState {
  selectedTemplateSelections: TSelectedTemplateSelections;
}

const initialState: IInitialState = {
  selectedTemplateSelections: {},
};

const selectedTemplateSelectionsSlice = createSlice({
  name: 'selectedTemplateSelections',
  initialState,
  reducers: {
    selectTemplateSelection: (state, action: PayloadAction<ISelectSelectionPayload>) => {
      const { costCodeId, selection } = action.payload;

      if (Array.isArray(state.selectedTemplateSelections?.[costCodeId])) {
        state.selectedTemplateSelections[costCodeId].push(selection);
      } else {
        state.selectedTemplateSelections[costCodeId] = [selection];
      }
    },

    unselectTemplateSelection: (state, action: PayloadAction<IUnselectSelectSelectionPayload>) => {
      const { costCodeId, selectionId } = action.payload;

      const currentSelections = state.selectedTemplateSelections?.[costCodeId];

      if (!currentSelections) return;

      if (currentSelections?.length === 1) {
        delete state.selectedTemplateSelections[costCodeId];
        return;
      }

      state.selectedTemplateSelections[costCodeId] = currentSelections.filter(
        ({ id }) => id !== selectionId
      );
    },

    selectAllTemplateSelections: (state, action: PayloadAction<ISelectAllSelectionsPayload>) => {
      const { costCodeId, selections } = action.payload;

      if (!selections.length) return;

      if (
        Array.isArray(state.selectedTemplateSelections?.[costCodeId]) &&
        state.selectedTemplateSelections[costCodeId].length === selections.length
      ) {
        delete state.selectedTemplateSelections[costCodeId];
      } else {
        state.selectedTemplateSelections[costCodeId] = selections;
      }
    },

    resetSelectedTemplateSelections: (state) => {
      state.selectedTemplateSelections = {};
    },
  },
});

export const {
  resetSelectedTemplateSelections,
  selectAllTemplateSelections,
  selectTemplateSelection,
  unselectTemplateSelection,
} = selectedTemplateSelectionsSlice.actions;

export default selectedTemplateSelectionsSlice.reducer;
